import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

interface GetFileVersionListRequest {
  fileId: number;
  clientId?: number;
}

export interface FileVersionListItemType {
  id: number;
  name: string;
  editedAt: string;
}

interface GetFileVersionListResponse {
  file: FileVersionListItemType[];
}

const getFileVersionList = ({
  fileId,
  clientId,
}: GetFileVersionListRequest) => {
  return api.get<ApiResponse<GetFileVersionListResponse>>(
    '/file/version/list',
    {
      params: {
        fileId,
        clientId,
      },
    },
  );
};

const useFileVersionList = <
  TData = AxiosResponse<ApiResponse<GetFileVersionListResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  request: GetFileVersionListRequest,
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetFileVersionListResponse>>,
    TError,
    TData,
    ['getFileVersionList', GetFileVersionListRequest]
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(
    ['getFileVersionList', request],
    () => getFileVersionList(request),
    { ...options },
  );
};

export default useFileVersionList;
